app.service('searchShopDetails', function() {

	let controlDiv;

	const workingHoursRow = row =>
		`<div>${row.dateDescription}: ${row.workingHoursDescription}</div>`;

	function getHTML(shop) {
		return `
			<div class="js-show-details show-details"></div>
			<div class="list-item-top">
				<div class="shop-details-title">${shop.title}</div>
				<div class="street-address">
					${shop.street}
				</div>
				<div>${shop.postCode} ${shop.city}</div>
			</div>
			<div class="list-item-bottom">
				<div>${shop.description || ''}</div>
				<div>${shop.additionalDescription || ''}</div>
				<div>${shop.parkingType || ''}</div>
				<div>${shop.specialWorkingHours.map(workingHoursRow).join('') || ''}</div>
			</div>`;
	}

	function hide() {
		$(controlDiv).removeClass('is-visible');
	}

	function show( shop ) {
		const infoWindow = getHTML( shop );

		$(controlDiv).addClass('open is-visible').html(infoWindow);
	}

	function init(map) {
		controlDiv = document.createElement('div');
		controlDiv.index = 1;
		controlDiv.style.marginLeft = '30px';
		map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(controlDiv);
		controlDiv.className = 'shop-details';
		
		$(controlDiv).on('click', '.js-show-details', function() {
			$(controlDiv).toggleClass('open');
		});
	}

	return { show, hide, init };
});